export default __webpack_public_path__ + "static/media/norway-flag-icon.ff22f12c.svg";